import { SET_PERMISSIONS } from "../actions/auth.actions";

const permissions = {};

function authReducer(state = permissions, action){
    switch(action.type){
        case SET_PERMISSIONS: 
            
            return {...state, ...action.payload};
        default:
            return {...state}; 
    };
};

export default authReducer;